import { Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import localisations from "../localisation";

export type FileUploadProps = {
    id?: string;
    accept?: string;
    buttonText?: string;
    emptyText?: string;
    onSelect: (entity?: File) => void;
    file: File | undefined;
};

const HiddenInput = styled("input")({
    display: "none",
});

function getFileData(input: HTMLInputElement | null): File | undefined {
    if (!input || !input.files || !input.files.length) return undefined;
    return input.files[0];
}

function FileUpload(props: FileUploadProps) {
    const { buttonText, emptyText } = localisations.fileUpload;
    const [localFileData, setLocalFileData] = useState<File | undefined>();

    useEffect(() => {
        setLocalFileData(props.file);
    }, [props.file]);

    function onChange(e: React.ChangeEvent<HTMLInputElement>) {
        const file = getFileData(e.target);
        setLocalFileData(file);
        props.onSelect(file);
    }

    const id = props.id || "upload-file-input";

    return (
        <label htmlFor={id}>
            <HiddenInput accept={props.accept} id={id} type="file" onChange={onChange} />
            <Button variant="contained" component="span">
                {props.buttonText ?? buttonText}
            </Button>
            <Typography component="span" sx={{ marginLeft: 2 }}>
                {localFileData ? localFileData.name : props.emptyText ?? emptyText}
            </Typography>
        </label>
    );
}

export default FileUpload;
